<template>
  <div class="outerLayer">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{xdData.rybt}}</span>
      </div>
      <div class="continer">
        <div class="detail">
          <div class="headPortrait">
            <img v-if="xdData.lx == '1'" :src="xdData.rytx" alt="" class="portraitInfo">
            <img v-else :src="xdData.rytx" alt="" class="portraitInfo">
          </div>
          <div class="teamInformation">
            <div class="team">
              <div class="teamNameBox">
                <el-card class="teamTitle_card" shadow="always">
                  <div class="teamTitle">
                    战队名称 </div>
                  <div class="teamContent">{{xdData.deptName}}</div>
                </el-card>
              </div>
            </div>
            <div class="teamSloganBox">
              <el-card class="teamTitle_card" shadow="always">
                <div class="teamTitle">
                  战队口号 </div>
                <div class="teamContent">{{xdData.bmkh}}</div>
              </el-card>
            </div>
          </div>
        </div>
        <div class="detailBox">
          <el-card class="teamcontent_card" shadow="always">
            <div class="detailInfo"><span v-if="xdData.lx == '1'">战队</span><span v-else>个人</span>简介</div>
            <div class="detailText" v-if="xdData.lx == '1'" v-html="xdData.jj"></div>
            <div class="detailText" v-else v-html="xdData.jj"></div>
          </el-card>
          <el-card class="teamcontent_card" shadow="always">
            <div class="detailInfo">心得分享</div>
            <div class="detailText" v-if="xdData.lx == '1'" v-html="xdData.xdfx"></div>
            <div class="detailText" v-else v-html="xdData.xdfx"></div>
          </el-card>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        deptList: [],
        xdData: this.$route.params.xdItem
      }
    },
    mounted() {
      console.log(this.$route.params.xdItem);
    },
    methods:{
    },
    destroyed(){
      console.log('destroyed');
    },
    beforeDestroy(){
      document.getElementById("tab-/wel/details").getElementsByClassName("el-icon-close")[0].click();
    },
  }
</script>
<style scoped lang="scss">
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.clearfix {
  font-size: 22px;
  text-align: center;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.box-card {
  margin: 0 auto;
  width: 55vw;
  min-height: 700px;
  border-radius: 30px;
}
.teamTitle_card {
  width: 400px;
  margin-left: 20px;
  background-color: rgba(179,63,59,0.8);
  box-shadow: 0px 0px 24px -10px;
}
.teamcontent_card {
   min-width:690px;
   min-height: 130px;
   margin-top: 20px;
   background-color: rgba(119, 133, 143, 0.8);
   box-shadow: 0px 0px 24px -10px;
 }

.outerLayer {
  .continer {
    background-color: #fff;
    padding-bottom: 100px;
    .topTitle {
      padding: 20px 0 40px 0;
      font-size: 26px;
      color: black;
      text-align: center;
      margin-bottom: 20px;
    }
    .detail {
      display: flex;
      justify-content: center;
      .headPortrait {
        .portraitInfo {
          width: 265px;
          height: 360px;
          float: right;
        }
      }
      .teamTitle { // 战队名称,战队口号titlle
        width: 100px;
        height: 24px;
        line-height: 24px;
        font-size: 22px;
        font-weight: 500;
        color: #fff;
      }
      .teamContent { // 战队名称, 战队口号内容
        margin-top: 10px;
        font-size: 16px;
        font-weight: 500;
        color: #e5e5e5;
      }
      .teamInformation {
        .team {
          height: 40%;
          .teamNameBox {
            margin-top: 20px;
          }
        }
        .teamSloganBox {
          height: 50%;
        }
      }
    }
    .detailInfo { // 详细内容title
      width: 100px;
      height: 24px;
      line-height: 24px;
      font-size: 22px;
      font-weight: 500;
      color: #fff;
    }
    .detailBox {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 900px;
      margin: 0 auto;
    }
    .detailText {
      margin-top: 10px;
      color: #e5e5e5;
    }
  }
}
</style>
